import { useCallback, useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { useBlocker, useLocation, useNavigate } from "react-router-dom";
import LoadingButton from "components/shared/LoadingButton";

const GoalTrackingWatcher = ({ handleSave, isLoading }) => {
  const { values, dirty, setFieldValue } = useFormikContext();
  const { hasUnsavedChanges } = values;
  const navigate = useNavigate();
  const location = useLocation();
  // const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  // console.log("hasUnsavedChanges", hasUnsavedChanges)

  // const beforeunload = useCallback((e) => {
  //   if (hasUnsavedChanges) {
  //     e.preventDefault();
  //     e.returnValue = true;
  //   }
  // }, [hasUnsavedChanges])

  useEffect(() => {
    const trackings = values.goalTracking;
    if(!trackings?.length) {
      return;
    }

    const unsavedTrackings = trackings.filter(item => (!item.id && item.tracked));
    // setHasUnsavedChanges(!!unsavedTrackings?.length);
    setFieldValue("hasUnsavedChanges", !!unsavedTrackings?.length)
  }, [values.goalTracking])

  // Handle navigation warning
  // useEffect(() => {
  //   const handleBeforeUnload = (e) => {
  //     console.log("handleBeforeUnload", hasUnsavedChanges)
  //     if (hasUnsavedChanges) {
  //       e.preventDefault();
  //       e.returnValue = ""; // Required for showing the browser prompt
  //     }
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload); // Browser refresh

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, [hasUnsavedChanges]);

  // React Router navigation warning for links and back/forward buttons
  // const blocker = useBlocker(({ currentLocation, nextLocation }) => {
  //   if (dirty) {
  //     const confirmLeave = window.confirm(
  //       "You have unsaved changes. Are you sure you want to leave?"
  //     );
  //     if (!confirmLeave) {
  //       return true; // Block navigation
  //     }
  //   }
  //   return false; // Allow navigation
  // });

  if(!hasUnsavedChanges) {
    return null;
  }

  return (
    <div className="d-flex justify-content-center">
      <LoadingButton
        className="d-flex align-items-center justify-content-center commonBtn fw-sbold"
        onClick={() => {
          handleSave(values.goalTracking);
        }}
        isLoading={isLoading}
      >
        Save Goal Tracking
      </LoadingButton>
    </div>
  );
};

export default GoalTrackingWatcher;